import { useContext, useMemo } from 'react';
import MembersContext from 'router/subrouters/DataRoom/providers/Members/Members.context';
import { isDataRoomAdminOrOwner } from 'router/subrouters/DataRoom/utils';

export default function useRfiGrantAccess(
  grantAccessDataRoomMemberIds: string[],
) {
  const { allMembers } = useContext(MembersContext);

  const membersThatAreNotAdmins = useMemo(
    () => allMembers.filter(({ role }) => !isDataRoomAdminOrOwner(role)),
    [allMembers],
  );

  const membersOptions = useMemo(
    () =>
      membersThatAreNotAdmins.map(({ _id, fullName, email }) => ({
        value: _id,
        label: fullName || email,
      })),
    [membersThatAreNotAdmins],
  );

  const membersInitialValue = useMemo(
    () =>
      membersThatAreNotAdmins.reduce<Record<string, boolean>>(
        (acc, { _id }) => {
          acc[_id] = grantAccessDataRoomMemberIds?.includes(_id);
          return acc;
        },
        {},
      ),
    [grantAccessDataRoomMemberIds, membersThatAreNotAdmins],
  );

  return { membersOptions, membersInitialValue };
}
